import axios from "axios";
import buildUrl from "build-url-ts";
import EventService from '../utils/event.service';
import { TrackEventForAdoptionRequest } from "src/types/adoption";

const apiUrl = process.env.REACT_APP_API_URL;
const ADOPTION_BASE_URL = `${apiUrl}/api/2.0/adoption`;

//Identify User for Adoption
export const identifyUserForAdoption = async (): Promise<void> => {
  const distinctId = EventService.getMixpanelDistinctId();
  const url = buildUrl(ADOPTION_BASE_URL, {
    path: `/identify/${distinctId}`,
  });

  await axios.post(url);
};

// Track Event
export const trackEventForAdoption = async (
  event: TrackEventForAdoptionRequest
): Promise<void> => {
  const distinctId = EventService.getMixpanelDistinctId();

  const eventPayload = {
    ...event,
    properties: JSON.stringify({
      ...event.properties,
      distinct_id: distinctId,
      platform: "Paperflite Web",
    }),
  };

  const url = buildUrl(ADOPTION_BASE_URL, {
    path: "/event",
  });

  await axios.post(url, eventPayload);
};
